/**
 * AccountTimezoneScreen — l'écran « Fuseau horaire » (`account-timezone`), pour tous les comptes.
 *
 * Un fil : la liste des fuseaux (seulement en manuel), le view-model, les gestes, puis la page.
 * Ouvert depuis le portail Abonnement du parent et depuis la ligne d'accès des réglages élève et
 * tuteur (exception datée, `ports/TRANSITION.md`).
 */
import { useSelector } from "react-redux"

import { AccountTimezonePage } from "../../../../../../design-system"
import { accountTimezoneViewModel } from "../../../../view-models/account/Timezone/accountTimezoneViewModel"
import { useAccountTimezoneData } from "./useAccountTimezoneData"
import { useAccountTimezoneState } from "./useAccountTimezoneState"

export function AccountTimezoneScreen() {
    const data = useAccountTimezoneData()
    const vm = useSelector((state: unknown) => accountTimezoneViewModel(state, data.raw))
    const gestures = useAccountTimezoneState({ timezone: vm.timezone, auto: vm.auto, onManual: data.load })

    return (
        <AccountTimezonePage
            currentCity={vm.currentCity}
            currentLabel={vm.currentLabel}
            auto={gestures.auto}
            autoHint={vm.autoHint}
            autoSaving={gestures.autoSaving}
            onToggleAuto={gestures.onToggleAuto}
            errorMessage={gestures.errorMessage}
            options={vm.options}
            optionsLoading={data.loading}
            optionsError={data.error}
            onRetryOptions={data.retry}
            selectedTimezoneId={vm.auto ? null : vm.timezone}
            savingTimezoneId={gestures.savingTimezoneId}
            onSelectTimezone={gestures.onSelectTimezone}
            onClose={gestures.onClose}
        />
    )
}

export default AccountTimezoneScreen
